import { FC } from 'react';

// ========================= 组件 =========================
import Link from '@/components/link';
import { RightOutlined } from '@ant-design/icons';

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================

// ========================= 样式 =========================
import styles from './index.module.css';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface LoadMoreButtonProps extends React.HTMLAttributes<HTMLDivElement> {
    buttonText?: string;
    linkHref?: string;
    linkProps?: { locale?: string }
}

const LoadMoreButton: FC<LoadMoreButtonProps> = ({
    buttonText = '查看更多',
    linkHref = '#',
    linkProps
}) => {
    return (
        <div className={styles.LoadMore}>
            <Link href={linkHref} {...linkProps}>
                {buttonText}<RightOutlined className={styles['LoadMore-icon']} />
            </Link>
        </div>
    );
}
export default LoadMoreButton;